'use client'
import React from 'react'
import styled from 'styled-components'
import WidthContainer from '../../elements/widthContainer'
import { SectionElement } from '../../compositions/articleSection'
import ShareBlock from '../../modules/_subsite/share'

const Wrapper = styled.div`
  margin-top: ${(props) => `${props.topSpacing || 0}px`};
  margin-bottom: ${(props) => `${props.bottomSpacing || 0}px`};

  display: inline-block;
  vertical-align: top;
  width: calc(100% - 340px);

  @media screen and (max-width: 1000px) {
    width: 100%;
  }

  .imagesContainer {
    width: calc(100% + 340px) !important;
    span {
      overflow: visible !important;
      img {
        overflow: visible;
        object-fit: cover;
      }
    }
  }
`

const BodySection = ({
  content,
  bottomSpacing = 0,
  topSpacing = 66,
  share = false,
}) => {
  if (!content || content.length == 0) {
    return null
  }
  return (
    <WidthContainer variant="semi">
      <Wrapper bottomSpacing={bottomSpacing} topSpacing={topSpacing}>
        {content?.map((item, i) => {
          return <SectionElement {...item.value} key={`body-section-${i}`} />
        })}
        {share && <ShareBlock />}
      </Wrapper>
    </WidthContainer>
  )
}

export default BodySection
